import { usePageMeta } from "../lib/seo";
import { Figure } from "../components/site/Figure";

const paragraphs = [
  `I've been a licensed contractor since 1989 and bring my passion for building and decades of experience to every project. Prior to creating Sandquist Construction, I was a tradesman, starting in production and then moving into custom framing and carpentry. While my focus is now on the project management and supervision of small and large projects — everything from remodels to building entire custom homes — I still take pride in being hands on and "getting my boots dirty."`,
  `In order to provide each project and client my attention and expertise, I prefer to take no more than two or three projects at one time. I am not a salesman that will pitch and then be out of sight. I like to be involved in the details out in the field and on the job, accountable for all the work, and supervising the project from start to finish.`,
  `I work with a set of highly skilled carpenters and builders and have forged strong relationships with architects and sub-contractors, creating partnerships of trust and respect while working together for many years. I know their capabilities, their craftsmanship, and their dependability to deliver each project with the utmost quality within a given timeline.`,
  `It is always my goal that clients are as happy in the end as they are excited in the beginning. Ultimately, it's not only about building quality, but also taking care of a client's house and property through the entire process.`,
];

export default function About() {
  usePageMeta(
    "About Rick Sandquist — East Bay Custom Home Builder Since 1989",
    "Rick Sandquist, licensed California contractor since 1989. Tradesman first — production, then custom framing and carpentry — before founding Sandquist Construction in Berkeley. CA License #572537."
  );

  return (
    <main data-testid="about-page">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24 pb-16 sm:pb-24">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">About Rick Sandquist.</h1>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-12 mt-12">
          <div className="lg:col-span-7 space-y-7 max-w-[65ch]" data-testid="about-copy">
            {paragraphs.map((p, i) => (
              <p key={i} className="text-base sm:text-lg leading-relaxed text-ink">{p}</p>
            ))}
            <p className="text-sm text-inkmuted pt-4" data-testid="about-press-line">
              Sandquist Construction's work has appeared in SFGate.
            </p>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            {/* [HEADSHOT — TBD] */}
            <Figure
              src="/photos/oakland-hills/oakland-hills-02-5-living-room.jpg"
              alt="Living room — Oakland Hills custom home by Sandquist Construction"
              tier="standard"
              caption="Oakland Hills — Oakland, California"
              testId="about-photo"
            />
          </div>
        </div>
      </div>
    </main>
  );
}
